import { useBusinessToolStore } from "store/useBusinessToolStore";
import { getBusinessPlan } from "store/useBusinessToolStore/selectors";
import { useUserStore } from "store/useUserStore";
import { getAuthUser } from "store/useUserStore/selectors";

export const useIsBusinessPlanOwner = () => {
  const businessPlan = useBusinessToolStore(getBusinessPlan);
  const userEmail = useUserStore(getAuthUser)?.email;

  return businessPlan.createdBy === userEmail;
}
